export const stockContants = {
  GET_ALL_STOCK_CATEGORIES: "GET_ALL_STOCK_CATEGORIES",
  GET_ALL_BRAND: "GET_ALL_BRAND",
  GET_ALL_SELLING_PRICES: "GET_ALL_SELLING_PRICES",
  GET_ALL_GOODS: "GET_ALL_GOODS",
  GET_ALL_INVENTORIES: "GET_ALL_INVENTORIES",
  GET_ALL_GOODUNITS: "GET_ALL_GOODUNITS",
};
